import {
    combineReducers
} from "redux";
import superAdminLoginReducer from '../slices/SuperAdminLogin';
import createTenantUserReducer from '../slices/createTenantUser';
import getAllTenantUserReducer from '../slices/getAllTenantUser';
import updateTenantReducer from "../slices/updateTenantAdmin";
import updateTenantUserReducer from "../slices/updateTenantUser";
import updateTenantUserPasswordReducer from "../slices/updateTenantUserPassword";
import updateTenantUserStatusReducer from "../slices/updateTenantUserStatus";
import createCropReducer from "../slices/createCrop";
import getByCropReducer from "../slices/getByCrop";
import getAllCropsReducer from "../slices/getAllCrop";
import updateCropReducer from "../slices/updateCrop";

import createVarietyReducer from "../slices/createVariety";
import getByVarietyReducer from "../slices/getByVariety";
import getAllVarietiesReducer from "../slices/getAllVariety";
import updateVarietyReducer from "../slices/updateVariety";

import getAllTenantsReducer from "../slices/getAllTenants";
import createUserReducer from "../slices/createUser";
import getAllUserReducer from "../slices/getAllUsers";
import tenantLoginReducer from "../slices/tenantLogin";
import createZoneReducer from "../slices/createZone";
import getAllZonesReducer from "../slices/getAllZones";
import getZoneByIdReducer from "../slices/getZoneById";
import updateZoneReducer from "../slices/updateZone";
import getUserByIdReducer from "../slices/getUserById";
import createRegionReducer from "../slices/createRegions";
import getAllRegionsReducer from "../slices/getAllRegions";
import getRegionByIdReducer from "../slices/getRegionById";
import updateRegionReducer from "../slices/updateRegion";
import createAreaReducer from "../slices/createArea";
import getAllAreasReducer from "../slices/getAllAreas";
import getAreaByIdReducer from "../slices/getAreaById";
import updateAreaReducer from "../slices/updateArea";
import createDistrictReducer from "../slices/createDistrict";
import getAllDistrictsReducer from "../slices/getAllDistrict";
import getDistrictByIdReducer from "../slices/getDistrictById";
import updateDistrictReducer from "../slices/updateDistricts";
import createMandalReducer from "../slices/createMandal";
import getAllMandalsReducer from "../slices/getAllMandals";
import getMandalByIdReducer from "../slices/getMandalById";
import updateMandalReducer from "../slices/updateMandal";
import createVillageReducer from "../slices/createVillage";
import getAllVillagesReducer from "../slices/getAllVillages";
import getVillageByIdReducer from "../slices/getVillageById";
import updateVillageReducer from "../slices/updateVillage";
import createDealerReducer from "../slices/createDealer";
import getAllDealersReducer from "../slices/getAllDealers";
import getDealerByIdReducer from "../slices/getDealerById";
import updateDealerReducer from "../slices/updateDealer";
import getAllSeasonsReducer from "../slices/getAllSeasons";
import createSeasonReducer from "../slices/createSeason";
import updateSeasonReducer from "../slices/updateSeason";
import createFarmerReducer from "../slices/createFormer";
import getAllFarmersReducer from "../slices/getAllFarmers";
import updateFarmerReducer from "../slices/updateFarmer";
import getAllSalesTargetsReducer from "../slices/getAllSalesTargets";
import getSalesTargetByIdReducer from "../slices/getSalesTargetById";
import updateSalesTargetReducer from "../slices/updateSalesTarget";
import createSalesTargetReducer from "../slices/createSalesTarget";
import createPreSeasonActivityReducer  from "../slices/createPreSeasonActivity";
import getAllPreSeasonActivitiesReducer from "../slices/getAllPreSeasonActivities";
import getPreSeasonActivityByIdReducer from "../slices/getPreSeasonActivitiyById";
import updatePreSeasonActivityReducer from "../slices/updatePreSeasonActivity";
import updatePostSeasonActivityReducer from "../slices/updatePostSeasonActivity";
import getPostSeasonActivityByIdReducer from "../slices/getPostSeasonActivityById";
import createPostSeasonActivityReducer from "../slices/createPostSeasonActivity";
import getAllPostSeasonActivitiesReducer from "../slices/getPostSeasonActivity";
import getAllFarmerCommitmentsReducer from "../slices/getAllFarmerCommitment";
import getFarmerCommitmentByIdReducer from "../slices/getFarmerCommitmentById";
import updateFarmerCommitmentReducer from "../slices/updateFarmerCommitment";
import createFarmerCommitmentReducer from "../slices/createFarmerCommitment";
import farmerCommitmentReducer from "../slices/farmerCommitment";
import createMonthlyTargetReducer from "../slices/createMonthlyTarget";
import getAllMonthlyTargetsReducer from "../slices/getAllMonthlyTargets";
import createActivityReducer from "../slices/createActivity";
import getActivityByIdReducer from "../slices/getActivitiesById";
import updateActivityReducer from "../slices/updateActivites";
import getAllActivitiesReducer from "../slices/getAllActivities";
import createPostMonthlyTargetReducer from "../slices/createMonthlyTargetPost";
import getAllPostMonthlyTargetsReducer from "../slices/getAllPostMonthlyTargets";
import createPostActivityReducer from "../slices/createPostActivity";
import getAllPostActivityReducer from "../slices/getAllPostActivity";
import getPostActivityByIdReducer from "../slices/getPostActivityById";
import updatePostActivityReducer from "../slices/updatePostActivity";
import getAllMediaFilesReducer from "../slices/getAllMeadiaFiles";
import getAllPostMediaFilesReducer from "../slices/getAllPostMeadiaFiles";
import createDailyPunchReducer from "../slices/createPunchingLog";
import getAllDailyPunchesReducer from "../slices/getAllpunchingLogs";
import updateDailyPunchReducer from "../slices/updatePunchingLog";
import getDailyPunchByIdReducer from "../slices/getDailyPunchingLogByid";
import createDailyTaskReducer from "../slices/createDailyTask";
import getAllDailyTasksReducer from "../slices/getAllDailyTask";
import getDailyTaskByIdReducer from "../slices/getDailyTaskById";
import updateDailyTaskReducer from "../slices/updateDailyTask";
import loginWithOTPReducer from "../slices/loginWithOTP";
import verifyLoginOtpReducer from "../slices/verifyLoginOtp";
import forgotPasswordReducer from "../slices/forgotPassword";
import verifyForgotPasswordReducer from "../slices/verifyForgotPassword";
import  calculateSalesTargetReducer from "../slices/calculateSalesTarget";


export default combineReducers({
    superAdminLoginReducer,
    createTenantUserReducer,
    getAllTenantUserReducer,
    updateTenantReducer,
    updateTenantUserReducer,
    updateTenantUserPasswordReducer,
    updateTenantUserStatusReducer,
    createCropReducer,
    getByCropReducer,
    getAllCropsReducer,
    updateCropReducer,
    createVarietyReducer,
    getByVarietyReducer,
    getAllVarietiesReducer,
    updateVarietyReducer,
    getAllTenantsReducer,
    createUserReducer,
    getAllUserReducer,
    tenantLoginReducer,
    createZoneReducer,
    getAllZonesReducer,
    getZoneByIdReducer,
    updateZoneReducer,
    getUserByIdReducer,
    createRegionReducer,
    getAllRegionsReducer,
    getRegionByIdReducer,
    updateRegionReducer,
    createAreaReducer,
    getAllAreasReducer,
    getAreaByIdReducer,
    updateAreaReducer,
    createDistrictReducer,
    getAllDistrictsReducer,
    getDistrictByIdReducer,
    updateDistrictReducer,
    createMandalReducer,
    getAllMandalsReducer,
    getMandalByIdReducer,
    updateMandalReducer,
    createVillageReducer,
    getAllVillagesReducer,
    getVillageByIdReducer,
    updateVillageReducer,
    createDealerReducer,
    getAllDealersReducer,
    getDealerByIdReducer,
    updateDealerReducer,
    getAllSeasonsReducer,
    createSeasonReducer,
    updateSeasonReducer,
    createFarmerReducer,
    getAllFarmersReducer,
    updateFarmerReducer,
    getAllSalesTargetsReducer,
    getSalesTargetByIdReducer,
    updateSalesTargetReducer,
    createSalesTargetReducer,
    createPreSeasonActivityReducer,
    getAllPreSeasonActivitiesReducer,
    getPreSeasonActivityByIdReducer,
    updatePreSeasonActivityReducer,
    updatePostSeasonActivityReducer,
    getPostSeasonActivityByIdReducer,
    createPostSeasonActivityReducer,
    getAllPostSeasonActivitiesReducer,
    getAllFarmerCommitmentsReducer,
    getFarmerCommitmentByIdReducer,
    updateFarmerCommitmentReducer,
    createFarmerCommitmentReducer,
    farmerCommitmentReducer,    
    createMonthlyTargetReducer,
    getAllMonthlyTargetsReducer,
    createActivityReducer,
    getActivityByIdReducer,
    updateActivityReducer,
    getAllActivitiesReducer,
    createPostMonthlyTargetReducer,
    getAllPostMonthlyTargetsReducer,
    createPostActivityReducer,
    getAllPostActivityReducer,
    getPostActivityByIdReducer,
    updatePostActivityReducer,
    getAllMediaFilesReducer,
    getAllPostMediaFilesReducer,
    createDailyPunchReducer,
    getAllDailyPunchesReducer,
    updateDailyPunchReducer,
    getDailyPunchByIdReducer,
    createDailyTaskReducer,
    getAllDailyTasksReducer,
    getDailyTaskByIdReducer,
    updateDailyTaskReducer,
    loginWithOTPReducer,
    verifyLoginOtpReducer,
    forgotPasswordReducer,
    verifyForgotPasswordReducer,
    calculateSalesTargetReducer,
});